module.exports = __webpack_public_path__ + "static/media/image2.b48e45e1.jpg";